import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Button, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import { DANHMUCVANBANGCHUNGCHI_API } from '@app/utils/apiUrl';
import { DeleteSingle, Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '../../../../utils/helper';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import { messageToast, objectShowNumber, status200 } from '../../../../utils/define';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';

// Thêm hàm helper mapping giá trị Enum thành text tiếng Việt
const formatDoiTuongApDung = (value) => {
    if (!value && value !== 0) return '';
    
    const mapping = {
        'BacSi': 'Bác sĩ',
        'DieuDuong': 'Điều dưỡng',
        'KyThuatVien': 'Kỹ thuật viên',
        // Đề phòng backend trả về số nguyên thay vì chuỗi string
        1: 'Bác sĩ',
        2: 'Điều dưỡng',
        3: 'Kỹ thuật viên'
    };

    // Xử lý trường hợp có [Flags] (nhiều giá trị nối nhau bằng dấu phẩy, vd: "BacSi, DieuDuong")
    if (typeof value === 'string' && value.includes(',')) {
        return value
            .split(',')
            .map(item => mapping[item.trim()] || item.trim())
            .join(', ');
    }

    return mapping[value] || value;
};

const DanhMucVanBangChungChi = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (paramUrl.get('page') != null && parseInt(paramUrl.get('page'), 10) !== page) {
        setPage(parseInt(paramUrl.get('page'), 10));
    }
    if (paramUrl.get('size') != null && parseInt(paramUrl.get('size'), 10) !== pageSize) {
        setPageSize(parseInt(paramUrl.get('size'), 10));
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    const replaceHistory = (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(location.pathname, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['danhMucVanBangChungChiData', valueSearch, page, pageSize],
        () => {
            const model = {
                Keyword: valueSearch || '',
                PageIndex: page,
                PageSize: pageSize
            };
            replaceHistory(page, pageSize, valueSearch);
            return Get(DANHMUCVANBANGCHUNGCHI_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            setPage(1);
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search);
    };

    const deleteFunc = useMutation((value) => DeleteSingle(DANHMUCVANBANGCHUNGCHI_API.DELETE_ITEM, value, null));

    const deleteAction = (e, id, name) => {
        e.preventDefault();
        e.stopPropagation();
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (idWantDelete === '') return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || messageToast.messageToastTryCatch);
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    return (
        <div className="container-fluid">
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <h5>Danh mục văn bằng chứng chỉ</h5>
                        <div className="d-flex">
                            <NavLink to={URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_CREATE_PATH} className="btn btn-success">
                                Thêm mới
                            </NavLink>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>Tên</th>
                                    <th>Đối tượng áp dụng</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={5}>Đang tải...</td>
                                    </tr>
                                ) : isError ? (
                                    <tr>
                                        <td colSpan={5}>Lỗi: {error?.message || 'Không tải được dữ liệu'}</td>
                                    </tr>
                                ) : items.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>Không có dữ liệu</td>
                                    </tr>
                                ) : (
                                    items.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{item.ten || item.Ten}</td>
                                            
                                            {/* Đã sửa: Gọi hàm mapping để hiển thị nhãn tiếng Việt */}
                                            <td>{formatDoiTuongApDung(item.doiTuongApDung || item.DoiTuongApDung)}</td>
                                            
                                            <td>
                                                <NavLink
                                                    className="btn btn-primary btn-sm mr-2"
                                                    to={`${URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_EDIT_PATH}?id=${item.id}`}>
                                                    Sửa
                                                </NavLink>
                                                <Button
                                                    type="button"
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={(e) => deleteAction(e, item.id, item.ten || item.Ten)}>
                                                    Xóa
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                {objectShowNumber.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.text}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div>
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                innerClass="pagination pagination-sm no-margin"
                                activePage={page}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                            />
                        </div>
                    </div>

                    <ConfirmModal
                        isOpen={openConfirmDeleteModal}
                        confirmType="delete"
                        handleAccept={acceptDelete}
                        handleCancel={cancelDelete}
                        content={confirmDelMessage}
                    />
                </Card.Body>
            </Card>
        </div>
    );
};

export default DanhMucVanBangChungChi;